import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { useAppSelector } from '../../../../lib/store';
import { useGetAnnotationWorkspaceQuery } from '../../api/annotationApiSlice';
import { selectSelectedNoteId } from '../../state/selector';
import type { Annotation, Concept, Encounter, Note } from '../../types/response';

export interface UseAnnotationContentResult {
  encounterData: Encounter | undefined;
  isEncounterDataLoading: boolean;
  selectedNote: Note | null;
  concepts: Concept[] | null;
  annotations: Annotation[] | null;
  taskStatus: string | null;
}

export const useAnnotationContent = (): UseAnnotationContentResult => {
  const { taskId } = useParams();

  const selectedNoteId = useAppSelector(selectSelectedNoteId);
  const {
    data: annotationWorkspaceData,
    isLoading: isAnnotationWorkspaceLoading,
    isFetching: isAnnotationWorkspaceFetching,
  } = useGetAnnotationWorkspaceQuery({ taskId: taskId as string });

  const selectedNote = useMemo(() => {
    if (!annotationWorkspaceData?.data?.notes || !selectedNoteId) return null;
    return annotationWorkspaceData.data.notes.find((n) => n.noteId === selectedNoteId);
  }, [annotationWorkspaceData, selectedNoteId]);
  return {
    encounterData: annotationWorkspaceData?.data?.encounter,
    concepts: annotationWorkspaceData?.data?.concepts ?? null,
    annotations: annotationWorkspaceData?.data?.annotations ?? null,
    isEncounterDataLoading: isAnnotationWorkspaceLoading || isAnnotationWorkspaceFetching,
    selectedNote: selectedNote ?? null,
    taskStatus: annotationWorkspaceData?.data?.task.status ?? null,
  };
};
